import { api } from '../lib/api';

/** GET /v1/me */
export interface Me {
  id: string;
  email: string;
  name: string | null;
  avatarUrl: string | null;
  createdAt: string;
  memberships: Array<{ orgId: string; role: string; org: { name: string; slug: string } }>;
}

export function fetchMe(): Promise<Me> {
  return api<Me>('/v1/me');
}

export function updateMe(body: { name?: string | null }): Promise<Me> {
  return api<Me>('/v1/me', { method: 'PATCH', body });
}

/** The file goes up as base64 in JSON; the API caps it at 2 MB. */
export async function uploadAvatar(file: File): Promise<Me> {
  const data = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error);
    reader.onload = () => resolve(String(reader.result).split(',')[1] ?? '');
    reader.readAsDataURL(file);
  });
  return api<Me>('/v1/me/avatar', { method: 'PUT', body: { contentType: file.type, data } });
}

export function removeAvatar(): Promise<Me> {
  return api<Me>('/v1/me/avatar', { method: 'DELETE' });
}

export function deleteAccount(): Promise<void> {
  return api<void>('/v1/me', { method: 'DELETE' });
}
